import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { Subject } from 'rxjs';
import 'firebase/database';
import { AuthService } from 'src/app/core/services/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../core/services/globals.service";
import * as i3 from "@angular/common/http";
import * as i4 from "../../core/services/ls-helper.service";
import * as i5 from "../../core/services/auth.service";
export class NotificationService extends BaseProvider {
    constructor(router, globals, http, ls, authService) {
        super();
        this.router = router;
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.authService = authService;
        this.roles = [];
        this.showManagement = false;
        this.item = {};
        this.messageCount = 0;
        this.isLoading = false;
        this.showNotifications = false;
        this.notificationRefresh = new Subject();
        this.baseUrl = 'messaging';
    }
    loadMessagingCount() {
        const userId = this.ls.get('userId');
        if (userId) {
            // this.firebasedb  = firebase
            // 		.database()
            // 		.ref('messaging/' + userId + '/info');
            // this.firebasedb.on("value", (resp)=> {
            // 	this.getCount();
            // });
        }
    }
    get() {
        this.isLoading = true;
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            const loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.isLoading = false;
                this.list = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getCount() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/count';
            const loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.messageCount = data.Data ? data.Data : 0;
                console.log('this.messageCount: ' + this.messageCount);
                resolve(this.messageCount);
            }, err => { reject(err); });
        });
    }
    updateSeen(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/seen/' + params.Id;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                if (!params.Seen) {
                    this.messageCount--;
                }
                this.gotoUrl(params);
                resolve(data);
            }, err => { reject(err); });
        });
    }
    gotoUrl(item) {
        // let url = item.UriPathTemplate;
        // url = url.replace('{0}', item.EntityId);
        // this.router.navigate([url]);
        if (this.authService.hasRole('tecnico interno')) {
            this.router.navigate(['/transactions-admin/', item.EntityId]).finally(() => {
                window.location.reload();
            });
        }
        else {
            this.router.navigate([item.UriPathTemplate.replace('{0}', item.EntityId)]);
        }
    }
    clearInbox() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/clear';
            this.http
                .put(this.url, {})
                .subscribe((data) => {
                this.list = [];
                resolve(data);
            }, err => { reject(err); });
        });
    }
    deleteMessage(messageId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/${messageId}`;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                this.list = this.list.filter(function (e) {
                    return e.Id !== messageId;
                });
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
NotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.GlobalsService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.LsHelperService), i0.ɵɵinject(i5.AuthService)); }, token: NotificationService, providedIn: "root" });
